import tokenService from '../_services/tokenService';

export function authHeader() {
  // return authorization header with jwt token
  // First try the new token service
  const token = tokenService.getToken();
  if (token) {
    return { Authorization: 'Bearer ' + token };
  }

  // Fallback to existing user object method
  let user = JSON.parse(localStorage.getItem('user'));
  if (user && user.token) {
    return { Authorization: 'Bearer ' + user.token };
  } else {
    return {};
  }
}
